module.exports = __webpack_public_path__ + "img/icon-verify.496ba9e3.svg";